import {
	MY_REVIEWS_PAGE_COMPLETE_REQUEST,
	MY_REVIEWS_PAGE_COMPLETE_SUCCESS,
	MY_REVIEWS_PAGE_COMPLETE_ERROR,
	MY_REVIEWS_PAGE_RECENT_REQUEST,
	MY_REVIEWS_PAGE_RECENT_SUCCESS,
	MY_REVIEWS_PAGE_RECENT_ERROR,
	MY_REVIEWS_PAGE_DELETE_REQUEST,
	MY_REVIEWS_PAGE_DELETE_SUCCESS,
	MY_REVIEWS_PAGE_DELETE_ERROR
} from 'actions/MyAccountActions/myReviewsPageActions';
import { INIT } from 'utils/asyncStatusHelper';
import { createReducer } from 'utils/reducerUtils';

const defaultState = {
	asyncStatus: INIT
};

export const myCompleteReview = createReducer(
	MY_REVIEWS_PAGE_COMPLETE_REQUEST,
	MY_REVIEWS_PAGE_COMPLETE_SUCCESS,
	MY_REVIEWS_PAGE_COMPLETE_ERROR,
	defaultState
);

export const myRecentReview = createReducer(
	MY_REVIEWS_PAGE_RECENT_REQUEST,
	MY_REVIEWS_PAGE_RECENT_SUCCESS,
	MY_REVIEWS_PAGE_RECENT_ERROR,
	defaultState
);

export const myReviewDelete = createReducer(
	MY_REVIEWS_PAGE_DELETE_REQUEST,
	MY_REVIEWS_PAGE_DELETE_SUCCESS,
	MY_REVIEWS_PAGE_DELETE_ERROR,
	defaultState
);
